import styled, { ITheme } from '../../../../../theme'

const UsernameLabel = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 270px;
`
export default UsernameLabel
